import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateAppointmentIfNewMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  changes: Types.Appointments_Set_Input;
}>;


export type UpdateAppointmentIfNewMutation = { __typename?: 'mutation_root', update_appointments?: { __typename?: 'appointments_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'appointments', id: number, status: string }> } | null };


export const UpdateAppointmentIfNewDocument = gql`
    mutation updateAppointmentIfNew($id: bigint!, $changes: appointments_set_input!) {
  update_appointments(
    where: {id: {_eq: $id}, status: {_eq: "new"}}
    _set: $changes
  ) {
    affected_rows
    returning {
      id
      status
    }
  }
}
    `;
export type UpdateAppointmentIfNewMutationFn = Apollo.MutationFunction<UpdateAppointmentIfNewMutation, UpdateAppointmentIfNewMutationVariables>;

/**
 * __useUpdateAppointmentIfNewMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentIfNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentIfNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentIfNewMutation, { data, loading, error }] = useUpdateAppointmentIfNewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateAppointmentIfNewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentIfNewMutation, UpdateAppointmentIfNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentIfNewMutation, UpdateAppointmentIfNewMutationVariables>(UpdateAppointmentIfNewDocument, options);
      }
export type UpdateAppointmentIfNewMutationHookResult = ReturnType<typeof useUpdateAppointmentIfNewMutation>;
export type UpdateAppointmentIfNewMutationResult = Apollo.MutationResult<UpdateAppointmentIfNewMutation>;
export type UpdateAppointmentIfNewMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentIfNewMutation, UpdateAppointmentIfNewMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appointments/queries/updateAppointmentIfNew.mutation.gql}
 */
export async function updateAppointmentIfNew(
  variables: UpdateAppointmentIfNewMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateAppointmentIfNewMutation['update_appointments']>
export async function updateAppointmentIfNew(
  variables: UpdateAppointmentIfNewMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateAppointmentIfNewMutation>
export async function updateAppointmentIfNew(
  variables: UpdateAppointmentIfNewMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateAppointmentIfNewMutation['update_appointments'] | UpdateAppointmentIfNewMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateAppointmentIfNewMutation>(
    UpdateAppointmentIfNewDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_appointments
}